import styled from '../../config/theme'

const Container = styled.div`
  display: flex;
  align-items: flex-start;

  height: 100%;
  overflow: auto;
  padding: 20px;

  > * {
    flex: 1;
    position: relative;
    width: 100%;

    &:not(:first-child) {
      border-left: 1px solid ${props => props.theme.color.lightGray};

      &:before {
        content: 'OU';
        position: absolute;
        background: white;
        top: calc(50% - 10px);
        font-size: 11px;
        left: -11px;
        width: 22px;
        text-align: center;
        color: ${props => props.theme.color.gray};
        box-sizing: border-box;
      }
    }

  }

  @media screen and (max-width: ${props => props.theme.mediaQueries.modal}) {
    flex-direction: column;

    > * {
      padding-bottom: 30px;
      &:not(:first-child) {
        padding-top: 30px;
        border-left: none;
        border-top: 1px solid ${props => props.theme.color.lightGray};

        &:before {
          font-size: unset;
          top: -10px;
          left: calc(50% - 15px);
          width: 30px;
          padding: 0 5px;
        }
      }
    }
  }
`

const Form = styled.div`
  display: flex;
  flex-direction: column;
`

export {
  Container,
  Form,
}
